export class WaitingRoom {
    constructor() {
        this.endpoint = 'waiting-room'
        this.boot = [{ index : [
            () => {
            }
        ]}]
    }
}